import { FlexBoxProps, FlexCol } from '@xylabs/sdk-react'

import { useGeotoken } from '../../../Contexts'
import Erc721PropertyArea from './Erc721PropertyArea'
import InfoAccordian from './InfoAccordian'
import { RewardsDetails } from './Rewards'
import SettingsPropertyArea from './SettingsAccordian'

interface PropertyAreaProps extends FlexBoxProps {
  rewards?: boolean
}

const PropertyArea: React.FC<PropertyAreaProps> = ({ rewards = false, ...props }) => {
  const geotoken = useGeotoken()

  return (
    <>
      {geotoken ? (
        <FlexCol alignItems="stretch" {...props}>
          {rewards ?? <RewardsDetails margin={1} />}
          <InfoAccordian margin={1} />
          <SettingsPropertyArea margin={1} />
          <Erc721PropertyArea margin={1} />
        </FlexCol>
      ) : null}
    </>
  )
}

export default PropertyArea
